export const iconFontAwesomeHumanitarianMountainCity = (
	<i className="fa-solid fa-mountain-city"></i>
);
